import { TextField, Typography, Box, MenuItem } from "@mui/material";

export function SelectAnswer({ label, value = "", options = [] }) {
  return (
    <Box mb={2}>
      <Typography fontWeight="medium" mb={0.5}>
        {label}
      </Typography>
      <TextField fullWidth select size="small" value={value} variant="outlined">
        {options.map((opt) => (
          <MenuItem key={opt} value={opt}>
            {opt}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}
